/*
 *		Copyright (c) 2011-2022 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('accessWebClient')
    .controller('PublicFolderLandingController', [
        '$location',
        '$rootScope',
        '$scope',
        '$translate',
        '$q',
        'flashMessagesService',
        'PublicFolderResource',
        function (
            $location,
            $rootScope,
            $scope,
            $translate,
            $q,
            flashMessagesService,
            PublicFolderResource
        ) {
            $scope.isLoading = true;
            $scope.error = false;

            var loadPromises = [
                PublicFolderResource.get().$promise,
                $translate('public_folders_page_invalid_message')
            ];

            $q.all(loadPromises)
                .then(function (responses) {
                    $rootScope.rootFolder = responses[0];
                    $rootScope.defaultPath = $rootScope.rootFolder.getUrl(true);
                })
                .catch(function () {
                    $scope.error = true;
                    return $translate('public_folders_page_invalid_message').then(function (message) {
                        flashMessagesService.add(message, flashMessagesService.ERROR);
                    });
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        }
    ]);
